import { render } from "./AppMenu.vue?vue&type=template&id=846af992&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"

import "./AppMenu.vue?vue&type=style&index=0&id=846af992&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-846af992"],['__file',"src/AppMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "846af992"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('846af992', __exports__)) {
    api.reload('846af992', __exports__)
  }
  
  module.hot.accept("./AppMenu.vue?vue&type=template&id=846af992&scoped=true", () => {
    api.rerender('846af992', render)
  })

}


export default __exports__